import Vue from 'vue'
import VueRouter from 'vue-router'
import { canNavigate } from '@/libs/acl/routeProtection'
import {isUserLoggedIn, getHomeRouteForLoggedInUser, getUserData} from '@/auth/utils'
import pages from './routes/pages'
import suppliers from './routes/suppliers'
import workers from './routes/workers'
import projects from './routes/projects'
import products from './routes/products'
import editRecords from './routes/editRecords'
import quotations from './routes/quotations'
import invoices from './routes/invoices'
import receipts from './routes/receipts'
import refunds from './routes/refunds'
import finances from './routes/finances'
import messages from './routes/messages'
import analysis from './routes/analysis'
import Swal from 'sweetalert2'

import settings from './routes/settings'
import axiosIns from '@/libs/axios'
import { EventBus } from '@/main'


Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    ...pages,
    ...workers,
    ...suppliers,
    ...settings,
    ...projects,
    ...products,
    ...editRecords,
    ...quotations,
    ...invoices,
    ...receipts,
    ...refunds,
    ...finances,
    ...messages,
    ...analysis,
  ],
})

const unreadMessage = () => {
  axiosIns.get('/messages/unread', {params: {user_id: getUserData().id, user_type_id: getUserData().user_type_id}}).then((res) => {
    const unread_messages = res.data.messages && res.data.messages.filter(message => message.is_read == 0)
    // const unread_messages = [{id: 1, title: "test", text: "test"}, {id: 2, title: "test2", text: "test2"}];
    if (unread_messages.length > 0) {
      showNextMessage(unread_messages, 0)
    }
  }).catch((error) => {
    console.log(error);
  });
}

const showNextMessage = (messages, index) => {
  if (index < messages.length) {
    const message = messages[index]
    Swal.fire({
      title: message.title,
      text: message.content,
      icon: 'warning',
      confirmButtonText: '確定',
    }).then(() => {
      axiosIns.post('/messages/read',{id: message.id}).then(() => {
        EventBus.$emit('messages:read-updated')
        showNextMessage(messages, index + 1)
      }).catch((error) => {
        console.log(error);
      });
    })

  }
}

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()
  const userData = getUserData()
  if (isLoggedIn) {
    unreadMessage()
  }
  // 新增的逻辑
  if (to.path === '/') {
    if (userData && userData.user_type_id === 2) {
      return next({ name: 'order-customer-view' })
    } else if (userData && userData.user_type_id === 3) {
      return next({ name: 'supplier-view', params: { id: userData.id }  })
    } else if (userData && userData.user_type_id === 4) {
      return next({ name: 'worker-view', params: { id: userData.id } })
    }
  }

  //
  if (isLoggedIn && userData && [2,3,4].includes(Number(userData.user_type_id))) {
    const mustChange = String((userData && userData.must_change_password) || '0') === '1'
    if (mustChange && to.name !== 'force-password') {
      return next({ name: 'force-password' })
    }
    if (!mustChange && to.name === 'force-password') {
      return next(getHomeRouteForLoggedInUser())
    }
  }

  // 原有的逻辑
  if (!canNavigate(to)) {
    if (!isLoggedIn) return next({ name: 'auth-login' })
    return next({ name: 'not-authorized' })
  }

  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    return next(getHomeRouteForLoggedInUser())
  }

  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
